import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import ReplayIcon from '@mui/icons-material/Replay';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import FactCheckOutlinedIcon from '@mui/icons-material/FactCheckOutlined';
import { teacherTypography } from '../../design/typography';
import StudentAvatarView from '../../shared/StudentAvatarView';
import './CeteleGeneralPanel.css';

function avatar(student, size = 30) {
  return <StudentAvatarView studentId={student.id} name={student.name}
    avatarId={student.avatar_id} starterEmoji={student.starter_emoji} size={size} />;
}

export default function CeteleGeneralPanel({
  detail, summary, displayed, page, pageCount, onPage,
  onStudentDetail, onEvaluation,
}) {
  const controls = detail.controls || [];

  const totals = [
    { key: 'total', label: 'Toplam kayıt', glyph: <FactCheckOutlinedIcon fontSize="small" />, value: summary.total },
    { key: 'retry', label: 'Tekrar kaydı', glyph: <ReplayIcon fontSize="small" />, value: summary.counts.retry },
    { key: 'pass', label: 'Öğrendi kaydı', glyph: <CheckCircleOutlineIcon fontSize="small" />, value: summary.counts.pass },
  ];
  return <Box className="ct6" data-testid="cetele-general-v6" sx={{
    '& h2': teacherTypography.sectionTitle,
    '& h3': teacherTypography.cardTitle,
    '& .ct6-metric-label': teacherTypography.metadata,
    '& .ct6-metric strong': teacherTypography.kpiValue,
    '& .ct6-matrix th': teacherTypography.tableHeader,
    '& .ct6-student': teacherTypography.studentName,
  }}>
    <section className="ct6-overview" aria-label="Tüm değerlendirmelerin özeti">
      <div className="ct6-heading">
        <div>
          <h2>Bütün çalışmalara bir bakış</h2>
        </div>
      </div>
      <p className="ct6-helper">
        Bütün kayıtların özeti. Bir öğrenci, farklı değerlendirmelerde birden fazla sonuç alabilir.
      </p>
      <div className="ct6-metrics" aria-label="Tüm değerlendirme sonuçları">
        {totals.map(metric => <div key={metric.key} role="group" aria-label={metric.label}
          className={'ct6-metric ct6-' + metric.key}>
          <span className="ct6-metric-icon" aria-hidden="true">{metric.glyph}</span>
          <strong>{metric.value}</strong>
          <Typography component="span" className="ct6-metric-label">{metric.label}</Typography>
        </div>)}
      </div>
    </section>
    <section className="ct6-matrix-card" aria-label="Öğrenci çetelesi">
      <div className="ct6-matrix-heading">
        <h2>Öğrenci Çetelesi ({summary.visible.length})</h2>
        <span>Tüm değerlendirme geçmişi</span>
      </div>
      <div className="ct6-matrix-scroll">
        <table className="ct6-matrix" aria-label="Genel Çetele" style={{ minWidth: displayed.length ? undefined : 0 }}>
          <thead><tr>
            <th className="ct6-sticky" scope="col">Öğrenci</th>
            {displayed.map(control => <th key={control.id} scope="col">{control.title}</th>)}
          </tr></thead>
          <tbody>
            {summary.visible.map(student => {
              return <tr key={student.id}>
                <td className="ct6-sticky">
                  <button type="button" className="ct6-student" onClick={() => onStudentDetail(student)}
                    aria-label={student.name + ' detayını gör'}>
                    {avatar(student, 30)}<span title={student.name}>{student.name}</span>
                  </button>
                </td>
                {displayed.map(control => {
                  const status = summary.byKey.get(String(student.id) + ':' + String(control.id));
                  return <td key={control.id}>
                    <span role="img" className={'ct6-dot ' + (status || 'none')}
                      aria-label={status === 'pass' ? 'Öğrendi' : status === 'retry' ? 'Tekrar' : 'Değerlendirilmedi'}>
                      {status === 'pass' ? '✓' : status === 'retry' ? '↻' : '·'}
                    </span>
                  </td>;
                })}
              </tr>;
            })}
          </tbody>
        </table>
        {!summary.visible.length && <p className="ct6-empty">Bu çetelede henüz öğrenci yok.</p>}
      </div>
      <div className="ct6-matrix-foot">
        <span>{summary.visible.length} öğrenci · {controls.length} değerlendirme</span>
        <div className="ct6-matrix-utilities">
          {pageCount > 1 && <div aria-label="Değerlendirme sütunları" className="ct6-pages">
            <button type="button" aria-label="Önceki değerlendirmeler" disabled={page === 0}
              onClick={() => onPage(page - 1)}>‹</button>
            <span>{page + 1}/{pageCount}</span>
            <button type="button" aria-label="Sonraki değerlendirmeler" disabled={page >= pageCount - 1}
              onClick={() => onPage(page + 1)}>›</button>
          </div>}
          <button type="button" className="ct6-evaluate-link" onClick={onEvaluation}>
            Değerlendirmeye geç →
          </button>
        </div>
      </div>
    </section>
  </Box>;
}
